import { render, staticRenderFns } from "./ManagePlans.vue?vue&type=template&id=81759b4c&scoped=true&"
import script from "./ManagePlans.vue?vue&type=script&lang=js&"
export * from "./ManagePlans.vue?vue&type=script&lang=js&"
import style0 from "./ManagePlans.vue?vue&type=style&index=0&id=81759b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81759b4c",
  null
  
)

export default component.exports